import { createAsyncThunk } from "@reduxjs/toolkit";
import { getContrasApi } from "../../../apiservice/accounts";

export const fetchContraRecord = createAsyncThunk(
  "contraRecord/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        selectedFilterType: filters.filterType,
        locationId: filters.locationId | null,
        customerId: filters.customerId | null,
        userId: filters.userId | null,
        fromDate: filters.fromDate,
        toDate: filters.toDate,
      };

      const res = await getContrasApi(payload);
  
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
